import { type ReactNode } from 'react';

import { Box, Stack, Typography } from '@mui/material';

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
  children?: ReactNode;
  compact?: boolean;
}

const PageHeader = ({
  eyebrow,
  title,
  description,
  actions,
  children,
  compact = false,
}: PageHeaderProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      justifyContent: 'space-between',
      alignItems: { xs: 'flex-start', md: 'flex-end' },
      gap: compact ? 1.5 : 2.5,
      mb: compact ? 2 : 3,
    }}
  >
    <Stack spacing={compact ? 0.25 : 0.75} sx={{ maxWidth: 760 }}>
      {eyebrow && (
        <Typography
          variant="caption"
          sx={{
            color: 'primary.main',
            fontWeight: 800,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
          }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography variant="h1">{title}</Typography>
      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
      {children}
    </Stack>
    {actions && (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexWrap: 'wrap',
          width: { xs: '100%', md: 'auto' },
          justifyContent: { xs: 'flex-start', md: 'flex-end' },
        }}
      >
        {actions}
      </Box>
    )}
  </Box>
);

export default PageHeader;
